import React, { forwardRef } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const NAVY = "#0f172a";
const SLATE = "#475569";
const MUTED = "#64748b";
const CRIMSON = "#A5122F";
const W = 720;
const REMARK_PLUGINS = [remarkGfm];

const md = {
  h1: ({ node, ...p }) => <h1 style={{ fontSize: 18, color: NAVY, margin: "10px 0 6px" }} {...p} />,
  h2: ({ node, ...p }) => <h2 style={{ fontSize: 14, color: NAVY, margin: "10px 0 5px" }} {...p} />,
  p: ({ node, ...p }) => <p style={{ fontSize: 11, lineHeight: 1.5, color: SLATE, margin: "0 0 6px" }} {...p} />,
  ul: ({ node, ordered, ...p }) => <ul style={{ margin: "0 0 6px", paddingLeft: 18, fontSize: 11, color: SLATE }} {...p} />,
  ol: ({ node, ordered, ...p }) => <ol style={{ margin: "0 0 6px", paddingLeft: 18, fontSize: 11, color: SLATE }} {...p} />,
  li: ({ node, ...p }) => <li style={{ margin: "0 0 3px" }} {...p} />,
  strong: ({ node, ...p }) => <strong style={{ color: NAVY }} {...p} />,
  table: ({ node, ...p }) => <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 10.5, margin: "0 0 8px" }} {...p} />,
  th: ({ node, ...p }) => <th style={{ textAlign: "left", padding: 4, borderBottom: `2px solid ${NAVY}` }} {...p} />,
  td: ({ node, ...p }) => <td style={{ padding: 4, borderBottom: "1px solid #e2e8f0" }} {...p} />,
};

// Generic off-screen print node for the analytics tabs. Renders a header,
// optional summary line, an optional data table (children), and the AI report.
const TabReportPrint = forwardRef(function TabReportPrint(
  { title, subtitle, reportMd, children },
  ref
) {
  return (
    <div aria-hidden="true" style={{ position: "absolute", width: 0, height: 0, overflow: "hidden", left: 0, top: 0 }}>
      <div ref={ref} style={{ width: W, background: "#fff", color: NAVY, fontFamily: "Arial, Helvetica, sans-serif", padding: "0 32px 32px" }}>
        <div style={{ borderBottom: `3px solid ${CRIMSON}`, paddingBottom: 12, marginBottom: 16 }}>
          <h1 style={{ margin: 0, fontSize: 22 }}>SalesTap — {title}</h1>
          {subtitle ? <p style={{ margin: "4px 0 0", fontSize: 12, color: MUTED }}>{subtitle}</p> : null}
        </div>

        {children ? <div style={{ marginBottom: 16 }}>{children}</div> : null}

        <div style={{ borderTop: `2px solid ${CRIMSON}`, paddingTop: 12 }}>
          {reportMd ? (
            <ReactMarkdown remarkPlugins={REMARK_PLUGINS} components={md}>{reportMd}</ReactMarkdown>
          ) : (
            <p style={{ fontSize: 11.5, color: MUTED }}>No AI analysis generated yet.</p>
          )}
        </div>
      </div>
    </div>
  );
});

export default TabReportPrint;
